import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  style: {
    paddingTop: '15px',
    '& label': {
      marginLeft: '8px',
    },
  },
});
